document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-item-option-help-tooltip').forEach(function (container) {
    const button = container.querySelector('.item-option-help-icon');
    const tooltip = container.querySelector('.item-option-help-text');

    const updateTooltip = function () {
      window.FloatingUIDOM.computePosition(button, tooltip, {
        placement: 'bottom',
        middleware: [
          window.FloatingUIDOM.flip(),
          window.FloatingUIDOM.shift(),
        ],
      }).then(({ x, y }) => {
        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
      });
    };

    const showTooltip = function () {
      tooltip.style.display = 'block';
      updateTooltip();
    };

    const hideTooltip = function () {
      tooltip.style.display = 'none';
    };

    container.addEventListener('mouseenter', showTooltip);
    container.addEventListener('mouseleave', hideTooltip);

    button.addEventListener('click', showTooltip);

    document.addEventListener('click', function (event) {
      if (!container.contains(event.target) && !button.contains(event.target)) {
        hideTooltip();
      }
    });
  });
});

// Small order fee popup.
//
// Warns customers with embroidered items that a $65 fee applies to runs of
// fewer than 6 items per logo. The fee is still applied manually in shipping —
// this is messaging only.
//
// It opens on page load rather than gating the checkout button because the
// accelerated checkout wallets (Shop Pay, PayPal) render in cross-origin
// iframes, so their clicks never reach a listener of ours. Firing on load is
// what covers every checkout path, express ones included.
//
// Whether a cart qualifies is decided in Liquid — sections/main-cart.liquid
// only renders the popup when the embroidered item count is under the
// threshold. There is no "continue to checkout" action because checkout is
// gated on picking a production time, so the button couldn't honor its label.
document.addEventListener('DOMContentLoaded', function () {
  // Looked up on demand rather than captured, so a theme editor re-render of
  // the cart section can't leave us holding a detached node.
  const openPopup = function () {
    const modal = document.getElementById('small-order-fee-popup');

    if (modal) modal.open();
  };

  openPopup();

  // Reopen while the merchant is editing the popup's settings, which re-renders
  // the section and would otherwise close it until a full page reload.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', openPopup);
  }

  // "Back to Shopping" links to a collection so it works without JS, but a real
  // browser back is friendlier when they arrived from a product page — it puts
  // them back on the item they were looking at rather than a listing.
  theme.addDelegateEventListener(document, 'click', '.js-small-order-fee-back', function (event) {
    if (!document.referrer) return;

    const referrer = new URL(document.referrer);

    // Nothing useful to go back to if we came from off-site, or from the cart
    // itself. Let the link's href handle those.
    if (referrer.origin !== window.location.origin) return;
    if (referrer.pathname === window.location.pathname) return;

    event.preventDefault();
    window.history.back();
  });
});
